"use strict";
var $ = require("../internals/export");
var uncurryThis = require("../internals/function-uncurry-this");
var requireObjectCoercible = require("../internals/require-object-coercible");
var toIntegerOrInfinity = require("../internals/to-integer-or-infinity");
var toString = require("../internals/to-string");
var fails = require("../internals/fails");
var charAt = uncurryThis("".charAt);
var FORCED = fails(function() {
  return "\u{20BB7}".at(-2) !== "\uD842";
});
$({ target: "String", proto: true, forced: FORCED }, {
  at: function at(index) {
    var S = toString(requireObjectCoercible(this));
    var len = S.length;
    var relativeIndex = toIntegerOrInfinity(index);
    var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
    return k < 0 || k >= len ? void 0 : charAt(S, k);
  }
});
